import { render } from "./InfoCodiciConto.vue?vue&type=template&id=45149dbb&scoped=true"
import script from "./InfoCodiciConto.vue?vue&type=script&lang=js"
export * from "./InfoCodiciConto.vue?vue&type=script&lang=js"

import "./InfoCodiciConto.vue?vue&type=style&index=0&id=45149dbb&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45149dbb"]])

export default __exports__